module.exports = __webpack_public_path__ + "img/mr.9c95d546.svg";